<header class="cover">
  <div class="cover--imageBackground">
    <video
      #coverVideo
      *ngIf="cover?.background_video; else coverImage"
      [src]="cover.background_video"
      autoplay
      muted
      loop
      playsinline
      (loadedmetadata)="playCoverVideo(coverVideo)"
    ></video>
    <ng-template #coverImage>
      <img [src]="cover?.background_image || company?.home_image?.original" />
    </ng-template>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-md-8 col-lg-6 p-4 position-relative mt-5">
        <div class="transparent-bg d-md-block"></div>

        <!-- Skeleton mientras carga el contenido del cover -->
        <ng-container *ngIf="webPageLoading; else coverContent">
          <div class="row">
            <div class="col-12">
              <div class="cover--skeleton cover--skeleton-title mb-2"></div>
              <div class="cover--skeleton cover--skeleton-title cover--skeleton-title--short mb-3"></div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-10 col-lg-12">
              <div class="cover--skeleton cover--skeleton-line mb-2"></div>
              <div class="cover--skeleton cover--skeleton-line mb-2"></div>
              <div class="cover--skeleton cover--skeleton-line cover--skeleton-line--short"></div>
            </div>
          </div>
        </ng-container>

        <ng-template #coverContent>
          <div class="row" *ngIf="cover?.title">
            <div class="col-12">
              <div
                class="cover--title text-primary mb-3 rich-text"
                [innerHTML]="cover.title | safeHtml"
              ></div>
            </div>
          </div>
          <div class="row" *ngIf="cover?.subtitle">
            <div class="col-md-10 col-lg-12">
              <div
                class="cover--description text-secondary mt-1 rich-text"
                [innerHTML]="cover.subtitle | safeHtml"
              ></div>
            </div>
          </div>
          <div class="row" *ngIf="cover?.buttons?.length">
            <div class="col d-flex align-items-center flex-wrap">
              <a
                *ngFor="let btn of cover.buttons; let i = index"
                [href]="btn.link"
                target="_blank"
                rel="noopener noreferrer"
                class="mt-3 mr-2"
                [ngClass]="i === 0 ? 'btn btn-info btn-flex btn-click-effect' : 'cover__btn-link'"
                >{{ btn.text }}<i *ngIf="i !== 0" class="fas fa-arrow-right ml-2" aria-hidden="true"></i></a
              >
            </div>
          </div>
          <div
            class="row"
            *ngIf="!cover?.buttons?.length && company?.allow_registration"
          >
            <div class="col">
              <a
                [routerLink]="['/register']"
                [state]="{ ignoreLoadingBar: true }"
                class="btn btn-info btn-flex btn-click-effect mt-3"
                >Crear cuenta</a
              >
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <!-- <div class="dots">
      <img class="" src="assets/images/home/dots.png" />
    </div> -->
  </div>
</header>
<div class="container-fluid px-0">
  <!-- <div class="row section-home justify-content-center">
    <div class="col-md-6 col-12 mb-3 mb-md-0">
      <div class="row">
        <div class="col-6 img-group">
          <div class="d-block">
            <img [src]="company?.institutional_1?.large" />
          </div>
          <div class="d-block">
            <img class="img-2" [src]="company?.institutional_2?.large" />
          </div>
        </div>
        <div class="col-6">
          <div class="d-block">
            <img class="img-3" [src]="company?.institutional_3?.large" />
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-11 align-items-end d-flex">
      <div class="row">
        <div
          class="card-home px-2 half-a-border-on-top half-a-border-on-bottom"
        >
          <div class="text-center mb-4">
            <h3 class="title">Acerca de nosotros</h3>
          </div>
          <p class="description">
            {{ company?.phrase || '' }}
          </p>
        </div>
        <div class="elipse">
          <img class="" src="assets/images/home/elipse.jpg" />
        </div>
      </div>
    </div>
  </div> -->

  <!-- Acerca de nosotros (about) -->
  <app-sblock-text
    alignImageBlock="left"
    type="image"
    [loading]="webPageLoading"
    [title]="about?.title"
    [subtitleText]="about?.short_description"
    [thumbnail]="about?.image"
    [backgroundImage]="about?.background_image"
    [btn1Active]="false"
    [btn2Active]="!!about?.full_description"
    [btn2Text]="'Leer más'"
    (btn2Action)="aboutModalOpen = true"
  ></app-sblock-text>

  <!-- Modal con la descripción completa de "Acerca de nosotros" -->
  <app-info-modal
    [open]="aboutModalOpen"
    [title]="about?.title"
    [content]="about?.full_description"
    (closed)="aboutModalOpen = false"
  ></app-info-modal>

  <!-- Propuesta de Valor (value_propositions) -->
  <app-sblock-sliders-grid
    class="d-block pt-md-5"
    [loading]="webPageLoading"
    [title]="valuePropsTitle"
    [subtitle]="valuePropsSubtitle"
    [slides]="valuePropsSlides"
    (slideClick)="openValueProp($event)"
  ></app-sblock-sliders-grid>

  <!-- Modal con la descripción completa de la propuesta de valor -->
  <app-info-modal
    [open]="valuePropModalOpen"
    [title]="valuePropModalTitle"
    [content]="valuePropModalContent"
    (closed)="valuePropModalOpen = false"
  ></app-info-modal>

  <!-- Título de la sección de niveles -->
  <div class="container px-0">
    <h2 class="home-levels-title">Niveles Educativos</h2>
  </div>
  <!-- Skeletons mientras cargan los niveles -->
  <ng-container *ngIf="levelsLoading">
    <app-sblock-text
      *ngFor="let s of levelSkeletons; let i = index"
      [loading]="true"
      type="image"
      [alignImageBlock]="i % 2 === 1 ? 'left' : 'right'"
    ></app-sblock-text>
  </ng-container>

  <!-- Niveles dinámicos: alternan la imagen (par a la derecha, impar a la izquierda) -->
  <ng-container *ngIf="!levelsLoading">
    <app-sblock-text
      *ngFor="let level of levels; let i = index"
      class="home-level d-block"
      [title]="'Nivel ' + level?.name"
      [subtitleText]="level?.short_description"
      [thumbnail]="level?.listing_image"
      [backgroundColor]="i % 2 === 0 ? '#EBF7F9' : '#FFFFFF'"
      type="image"
      [btn1Text]="'Conocer más'"
      [btn1Link]="'/level-profile/' + level.id"
      [btn2Active]="false"
      [alignImageBlock]="i % 2 === 1 ? 'left' : 'right'"
    ></app-sblock-text>
  </ng-container>
  <!-- Nuestra Casa (our_house) -->
  <app-sblock-gallery
    *ngIf="webPageLoading || galleryPhotos.length"
    title="Nuestra Casa"
    [loading]="webPageLoading"
    [photos]="galleryPhotos"
    [showCaptions]="true"
    [showActions]="false"
    [cardLayout]="true"
  ></app-sblock-gallery>

  <!-- Inscripciones (registrations) -->
  <app-sblock-text
    *ngIf="webPageLoading || registrations"
    [loading]="webPageLoading"
    type="image"
    alignImageBlock="left"
    [title]="registrations?.title"
    [thumbnail]="registrations?.image"
    [backgroundImage]="registrations?.background_image"
    [centered]="true"
    [btn1Active]="!!registrations?.button_text"
    [btn1Text]="registrations?.button_text"
    [btn1Link]="registrations?.button_link"
    [btn2Active]="false"
  ></app-sblock-text>

  <app-sblock-testimonials-2col
    id="comunidad"
    [loading]="webPageLoading"
    [title]="testimonialsTitle"
    [subtitle]="testimonialsSubtitle"
    [testimonials]="testimonials"
  ></app-sblock-testimonials-2col>
  <app-sblock-location [general]="general" [levels]="levels"></app-sblock-location>
  <app-sblock-form #contactForm></app-sblock-form>

  
  <!-- <app-sblock-text></app-sblock-text>
  <app-sblock-portada></app-sblock-portada>
  <app-sblock-course-list></app-sblock-course-list>
  <app-sblock-programs></app-sblock-programs>
  <app-sblock-events></app-sblock-events>
  <app-sblock-products></app-sblock-products>
  <app-sblock-consultancies></app-sblock-consultancies>
  <app-sblock-sliders></app-sblock-sliders>
  <app-sblock-cards></app-sblock-cards>
  <app-sblock-testimonials></app-sblock-testimonials>
  <app-sblock-faq></app-sblock-faq> -->
  <!-- ===== Fin bloques estáticos ===== -->
</div>
